import { Container } from '@/atoms';
import { Grid, Pagination } from '@/molecules';
import CardBlog from '@/molecules/card-blog';

import { routes } from '@/lib/routes';

import type { TypeCardBlogProps } from '@/molecules/card-blog';

type BlogProps = {
  bloque: {
    posts: (Omit<TypeCardBlogProps, 'excerpt'> & { excerpt: string })[];
    current: number;
    totalPages: number;
  };
  id?: string;
  className?: string;
};

/**
 * Blog
 */
export const Blog = ({ bloque, id, className }: BlogProps) => (
  <Container
    wrapper
    as="section"
    classNameWrapper="gap-10"
    {...(className && { className })}
    {...(id && { id })}
  >
    <Grid md={3} lg={3} className="gap-6 md:gap-x-8 md:gap-y-10">
      {bloque?.posts?.map((post, index) => (
        <Grid.Item key={index}>
          <CardBlog {...post} />
        </Grid.Item>
      ))}
    </Grid>

    <Pagination
      createURL={(page) =>
        page ? routes.blog.page(page + 1) : routes.blog.index
      }
      current={bloque.current - 1}
      totalPages={bloque.totalPages}
      className="mx-auto"
    />
  </Container>
);

Blog.displayName = 'Blog';
